import { ClaimType } from "@/shared/types";

export const OrderHistoryClaimTypeTabMap: Record<number, ClaimType> = {
  0: "DAMAGED",
  1: "MISSING",
  2: "INCORRECT",
  3: "ETC",
};
